import en from "./en";

// Russian locale — uses English as a deep base and overrides the primary
// user-visible marketing strings. Any deep key not overridden below falls
// back to English via the JSON clone, so nothing renders as "[missing key]".
//
// Translations here are AI-produced professional Russian and are intended
// as a strong first pass for the RU/CIS market rollout. A native-Russian
// marketing reviewer should refine the copy before high-volume campaigns.
const ru = JSON.parse(JSON.stringify(en));

ru.nav = {
  dashboard: "Панель управления",
  localization: "Локализация",
  industries: "Отрасли",
  engagement: "Как это работает",
  pricing: "Тарифы",
  insights: "Блог",
  about: "Почему Danny Clans",
  contact: "Контакты",
  professionalInquiry: "Получить доступ",
  hkIncorporated: "Зарегистрировано в Гонконге",
  language: "Язык",
};

ru.brand = {
  ...en.brand,
  tagline: "Масштабировать немасштабируемое",
  marketingLine: "Мы масштабируем то, что не могут другие.",
  complianceLine: "Зарегистрировано в САР Гонконг · Соответствует требованиям",
  responsePromise: "Ответ в течение 2–3 часов",
};

ru.cta = {
  primary: "Получить доступ",
  secondary: "Изучить панель управления",
  explore: "Изучить панель управления",
  submit: "Отправить профессиональный запрос",
  talkToPartner: "Связаться с партнёром",
  discussVertical: "Обсудить вашу вертикаль",
  planMarketEntry: "Спланировать выход на рынок",
  viewDetails: "Посмотреть функции",
  readPlaybook: "Читать плейбук",
  submitAnother: "Отправить ещё один запрос",
  seePricing: "Смотреть тарифы",
  exploreSolutions: "Изучить решения",
  seeVerticals: "Смотреть вертикали",
  discussRegion: "Обсудить {{region}}",
  buildEngine: "Построить ваш {{vertical}} движок",
  discussModule: "Обсудить {{module}}",
  read: "Читать",
};

ru.home = {
  ...en.home,
  heroTitle: "Одна панель. Все каналы. Один кошелёк.",
  heroSubtitle: "DC Dashboard предоставляет агентские рекламные аккаунты на Meta, Google, TikTok, Bing, Snap, LinkedIn, YouTube, Outbrain, Taboola и других площадках — финансирование через единый предоплаченный кошелёк, управление из Гонконга.",
  heroPill1: { title: "Агентские рекламные аккаунты", desc: "Подайте заявку один раз. KYC и комплаенс — на нас." },
  heroPill2: { title: "Один кошелёк, любой канал", desc: "Банк, карта, UPI или стейблкоины — финансируйте каждую платформу." },
  heroPill3: { title: "Отчётность, готовая к аудиту", desc: "Живые транзакции, документы комплаенса, экспорт." },
};

ru.stats = {
  enterprises: "Международных клиентов",
  markets: "Охваченных рынков",
  adSpend: "Ежемесячный рекламный бюджет",
  response: "Время ответа на запрос",
};

ru.ctaSection = {
  ...en.ctaSection,
  title: "Готовы управлять всеми каналами из одной панели?",
  subtitle: "Запросите агентские аккаунты, пополните единый кошелёк и масштабируйтесь по всему миру — с полной управляемостью.",
  badge: "Ответ 2–3 ч · Конфиденциально",
  dashboardTitle: "Управляйте каждым каналом из одной панели.",
  pricingTitle: "Получите письменное предложение.",
  engagementTitle: "Готовы подключиться к DC Dashboard?",
  industriesTitle: "Постройте трансграничный движок для вашей отрасли.",
  aboutTitle: "Конфиденциальный разговор, а не продажа.",
  localizationTitle: "Где вы хотите расти дальше?",
};

ru.footer = {
  ...en.footer,
  blurb: "DC Dashboard — единая платформа для медиабаинга. Агентские рекламные аккаунты, предоплаченный кошелёк, унифицированное управление кампаниями на каждом крупном канале. Создано в Гонконге. Работает по всему миру.",
  institutionalUpdates: "Институциональные обновления",
  newsletterHelp: "Ежеквартальные брифинги. Без спама. Отписка в любой момент.",
  subscribe: "Подписаться",
  solutions: "Панель управления",
  markets: "Рынки",
  company: "Компания",
  submitInquiry: "Отправить запрос",
  rights: "Все права защищены.",
  legal: "Зарегистрировано в САР Гонконг · Соответствует требованиям · Без гарантий эффективности.",
  enterEmailToast: "Пожалуйста, введите корректный email.",
  couldNotSubscribe: "Не удалось подписаться. Попробуйте ещё раз.",
  subscribed: "Подписка оформлена.",
  links: {
    dashboard: "DC Dashboard",
    masterAccounts: "Основные рекламные аккаунты",
    oneWallet: "Один кошелёк, несколько каналов",
    txnReporting: "Транзакции и отчётность",
    howItWorks: "Как это работает",
    pricing: "Тарифы",
    sea: "Юго-Восточная Азия",
    emea: "Европа и Америка",
    jpkr: "Япония и Корея",
    latam: "Латинская Америка",
    mena: "Ближний Восток и Африка",
    whyDc: "Почему Danny Clans",
    industries: "Отрасли",
    insights: "Блог",
    contact: "Контакты",
    admin: "Админ",
  },
};

ru.pages = {
  ...en.pages,
  insightsTitle: "Инсайты трансграничного роста для операторов и CMO.",
  insightsSubtitle: "Проверенные подходы к международной экспансии, росту и комплаенсу — для операторов и CMO.",
  insightsEmpty: "Скоро появятся новые материалы. Загляните позже.",
  insightNotFound: "Статья не найдена",
  insightNotFoundDesc: "Возможно, она была перемещена или снята с публикации.",
  allInsights: "Все статьи",
  insightCategory: "Блог",
  engagementTitle: "Как работает DC Dashboard — трансграничный онбординг в 5 шагов.",
  engagementSubtitle: "От регистрации до масштабных кампаний — задокументированный путь. Прозрачно, предоплата, готово к аудиту.",
  pricingTitle: "Тарифы агентских рекламных аккаунтов — пять планов, одна панель.",
  pricingSubtitle: "От Launch (бесплатно) до Media Buyer Scales++ (от $15 000 в месяц, enterprise). Выберите уровень под ваш бизнес.",
  dashboardTitle: "DC Dashboard — агентские рекламные аккаунты. Один кошелёк. Все каналы.",
  dashboardSubtitle: "Запросите агентские аккаунты на каждой крупной платформе, пополняйте единый предоплаченный кошелёк, запускайте кампании из одной консоли и получайте отчёты из живого журнала транзакций.",
  localizationTitle: "Нативные региональные рекламные кампании — SEA, EMEA, JP/KR, LATAM и MENA.",
  localizationSubtitle: "У каждого региона свои платформы, платежи, язык и законы. Переключайтесь между регионами, чтобы увидеть, как мы обеспечиваем выход на рынок.",
  industriesTitle: "Системы трансграничного роста для брендов, гейминга, приложений и e-commerce.",
  industriesSubtitle: "Бренды, игры, приложения и e-commerce требуют разных движков роста. Мы проектируем все четыре с одинаковой дисциплиной.",
  aboutTitle: "Danny Clans Media — партнёр трансграничного роста из Гонконга.",
  aboutSubtitle: "Danny Clans Media — институциональный партнёр трансграничного роста для глобальных брендов, игровых студий, приложений и e-commerce — создан, чтобы принести в отрасль, известную завышенными обещаниями, инфраструктуру, ориентированную на комплаенс.",
};

ru.contact = {
  ...en.contact,
  heroTitle: "Связаться с Danny Clans Media — получить доступ к агентским рекламным аккаунтам.",
  heroSubtitle: "Прямая, конфиденциальная консультация. Расскажите о своём бизнесе, и мы подберём подходящий план.",
  formTitle: "Расскажите о вашей инициативе",
  formHelp: "Все поля со звёздочкой (*) обязательны. Отвечаем в течение 2–3 часов в рабочие дни (HKT).",
  labels: {
    name: "Полное имя *",
    company: "Компания *",
    email: "Рабочий email *",
    phone: "Телефон (необязательно)",
    region: "Основной регион интереса",
    services: "Услуги интереса",
    message: "Контекст проекта *",
  },
  placeholders: {
    name: "Иван Иванов",
    company: "Ваша компания",
    email: "name@company.com",
    phone: "+7 …",
    message: "Кратко опишите ваш бизнес, целевые рынки и цели.",
  },
  submitting: "Отправка…",
  consent: "Отправляя, вы соглашаетесь с нашей политикой конфиденциальной консультации.",
  successTitle: "Спасибо. Мы ответим в течение 2–3 часов.",
  successKicker: "Запрос получен",
  referenceLabel: "Ваш номер:",
  successBody: "Партнёр Danny Clans свяжется с вами напрямую. Все коммуникации конфиденциальны.",
  sla: {
    kicker: "Соглашение об уровне сервиса",
    title: "Ответ в течение 2–3 часов",
    body: "Старший партнёр Danny Clans лично рассматривает и отвечает. Никаких ботов, никаких навязчивых продаж.",
  },
  next: {
    title: "Что произойдёт дальше",
    items: [
      "Подтверждение получения и номер обращения",
      "Конфиденциальный вводный звонок",
      "Рекомендация плана и объёма работ",
      "Доступ к панели и запуск",
    ],
  },
  errors: {
    required: "Обязательно",
    validEmail: "Требуется корректный email",
    minMessage: "Не менее 10 символов",
    pleaseFill: "Пожалуйста, заполните обязательные поля.",
    submitFailed: "Не удалось отправить. Попробуйте ещё раз.",
    inquiryReceived: "Запрос получен. Мы ответим в течение 2–3 часов.",
  },
};

ru.seo = {
  breadcrumbHome: "Главная",
  home: {
    metaTitle: "Агентские рекламные аккаунты Meta, Google и TikTok | Один кошелёк",
    metaDescription: "Получите агентские рекламные аккаунты на Meta, Google, TikTok, Bing, Snap, LinkedIn — с финансированием через единый предоплаченный кошелёк. Зарегистрировано в Гонконге.",
    keywords: "агентские рекламные аккаунты, аккаунты Meta, агентство Google Ads, аккаунты TikTok, трансграничная реклама, платформа медиабаинга, DC Dashboard",
    breadcrumbLabel: "Главная",
    ogTitle: "Ваша реклама. Наша инфраструктура.",
    ogDescription: "Доступ к 15+ рекламным платформам. Нулевой простой. Один кошелёк. Управляйте Meta, Google, TikTok и другими из одной панели.",
    imageAlt: "Danny Clans DC Dashboard — Один кошелёк, каждая рекламная платформа (Meta, Google, TikTok и др.).",
  },
  dashboard: {
    metaTitle: "DC Dashboard — Агентские аккаунты, один кошелёк, все каналы",
    metaDescription: "Агентские рекламные аккаунты на Meta, Google, TikTok, Bing, LinkedIn, YouTube. Пополните кошелёк один раз. Управляйте всеми кампаниями в единой консоли.",
    keywords: "агентские рекламные аккаунты, панель медиабаинга, предоплаченный рекламный кошелёк, мультиканальное управление, агентские аккаунты Meta, агентские аккаунты TikTok",
    breadcrumbLabel: "Панель",
  },
  pricing: {
    metaTitle: "Тарифы агентских аккаунтов — 5 планов от бесплатного до enterprise",
    metaDescription: "Прозрачные ежемесячные тарифы на агентские аккаунты Meta, Google, TikTok — Launch (бесплатно), Growth $300, Scale $500, Dominance $1 000, Enterprise.",
    keywords: "тарифы агентских рекламных аккаунтов, стоимость аккаунта Meta, цена агентского TikTok, планы медиабаинга, тарифы DC Dashboard",
    breadcrumbLabel: "Тарифы",
  },
  about: {
    metaTitle: "О Danny Clans Media — HK партнёр трансграничного роста",
    metaDescription: "Danny Clans Media — партнёр трансграничного роста, зарегистрированный в Гонконге, для глобальных брендов, игровых студий, приложений и e-commerce. Комплаенс превыше всего.",
    keywords: "Danny Clans Media, рекламное агентство Гонконг, партнёр трансграничного роста, медиабаинг с комплаенсом, зарегистрировано в САР Гонконг",
    breadcrumbLabel: "О нас",
  },
  contact: {
    metaTitle: "Связаться с Danny Clans Media — доступ к агентским аккаунтам",
    metaDescription: "Отправьте профессиональный запрос на доступ к DC Dashboard, агентским рекламным аккаунтам и трансграничному росту. Напрямую, конфиденциально — ответ за 2–3 часа.",
    keywords: "связаться с Danny Clans, доступ к агентскому аккаунту, профессиональный запрос, консультация по трансграничному медиабаингу",
    breadcrumbLabel: "Контакты",
  },
  industries: {
    metaTitle: "Трансграничный рост для брендов, гейминга, приложений и e-commerce",
    metaDescription: "Отраслевые системы трансграничного роста для глобальных брендов, игровых студий, приложений и e-commerce — с обеспечением через DC Dashboard.",
    keywords: "трансграничный рост, маркетинговое агентство брендов, привлечение пользователей в геймингe, мобильные приложения UA, трансграничная e-commerce реклама",
    breadcrumbLabel: "Отрасли",
  },
  localization: {
    metaTitle: "Региональные рекламные кампании — SEA, EMEA, JP/KR, LATAM и MENA",
    metaDescription: "Нативные трансграничные плейбуки для Юго-Восточной Азии, Европы и Америки, Японии и Кореи, LATAM и MENA. Локализованные аккаунты и платежи.",
    keywords: "нативная региональная реклама, реклама в Юго-Восточной Азии, медиабаинг LATAM, аккаунты Япония Корея, реклама MENA, трансграничная локализация",
    breadcrumbLabel: "Локализация",
  },
  engagement: {
    metaTitle: "Как работает DC Dashboard — трансграничный онбординг в 5 шагов",
    metaDescription: "От регистрации до масштабных мультиканальных кампаний за пять задокументированных шагов. Прозрачно, предоплата, готово к аудиту — принципы Danny Clans.",
    keywords: "как работает DC Dashboard, трансграничный онбординг, онбординг медиабаинга, настройка предоплаченного кошелька, обеспечение агентских аккаунтов",
    breadcrumbLabel: "Как это работает",
  },
  blog: {
    metaTitle: "Блог — Трансграничный рост, реклама и комплаенс",
    metaDescription: "Проверенные инсайты о трансграничном росте, агентских рекламных аккаунтах и комплаенсе — для операторов, CMO и руководителей агентств.",
    keywords: "блог трансграничного маркетинга, инсайты агентских аккаунтов, блог growth-маркетинга, инсайты рекламного комплаенса, блог медиабаинга",
    breadcrumbLabel: "Блог",
  },
};

// Section headings shared across the marketing pages.
ru.sections.faq.eyebrow = "FAQ";
ru.sections.faq.title = "Частые вопросы, прямые ответы.";
ru.sections.faqPricing.eyebrow = "FAQ";
ru.sections.faqPricing.title = "Частые вопросы по тарифам.";
ru.sections.partners.caption = "Работаем на всех крупных платформах и региональных экосистемах";
ru.sections.growthEngine = { eyebrow: "Внутри DC Dashboard", title: "Пять возможностей. Одна управляемая консоль.", desc: "Всё необходимое для управления агентскими рекламными аккаунтами на каждом крупном канале — от подготовки до комплаенса." };
ru.sections.advantages   = { eyebrow: "Почему DC Dashboard", title: "Создано для серьёзных трансграничных рекламодателей.", desc: "То, что даёт профессиональным медиабайерам несправедливое преимущество — встроено в панель." };
ru.sections.creative     = { eyebrow: "Поддерживаемые каналы", title: "Каждый значимый рекламный канал — в одном месте.", desc: "От глобальных гигантов до закрытых региональных экосистем. Подайте заявку один раз, управляйте везде." };
ru.sections.regional     = { eyebrow: "Локализация", title: "Нативные региональные кампании из одной панели.", desc: "У каждого региона свои платформы, платежи, язык и законы. Управляйте всеми из одной консоли." };
ru.sections.industry     = { eyebrow: "Отраслевые решения", title: "Отраслевые системы выхода на рынок.", desc: "Бренды, игры, приложения, e-commerce — каждая вертикаль работает на DC Dashboard." };
ru.sections.institutional= { eyebrow: "Институциональная надёжность", title: "Операционные доказательства, а не маркетинговые обещания.", desc: "Проверяемая регуляторная надёжность. Зарегистрировано в Гонконге, комплаенс превыше всего, готово к аудиту." };
ru.sections.why          = { eyebrow: "Почему Danny Clans Media", title: "Спокойно уверенные. Технически сложные. Прозрачные.", desc: "В отрасли, известной завышенными обещаниями, мы выделяемся комплаенсом, инфраструктурой и прямым общением." };
ru.sections.dashboard    = { eyebrow: "Внутри консоли", title: "Обзор DC Dashboard.", desc: "Кошелёк, транзакции, основные аккаунты и мультирельсовые пополнения — всё под одной крышей." };
ru.sections.payments     = { eyebrow: "Пополните кошелёк", title: "Любой платёжный рельс. Любой канал.", desc: "Банковский перевод, карта, UPI или стейблкоины на входе. Meta, Google, TikTok, Bing, Snap, LinkedIn, YouTube на выходе." };
ru.sections.capabilities = { eyebrow: "Возможности", title: "Пять столпов. Одна консоль.", desc: "Создано для трансграничных медиабайеров, которым нужны масштаб, комплаенс и контроль без жонглирования 14 платформами." };
ru.sections.engagementHow= { eyebrow: "Как работает DC Dashboard", title: "От регистрации до масштабных кампаний — пять шагов.", desc: "Задокументированный путь онбординга, используемый в каждом регионе и вертикали." };
ru.sections.opPrinciples = { eyebrow: "Операционные принципы", title: "Что гарантирует каждое взаимодействие с Danny Clans.", desc: "Мы не даём обязательств по конкретным метрикам эффективности. Мы даём обязательство по этому." };
ru.sections.aboutPrinc   = { eyebrow: "Операционные принципы", title: "Что направляет каждое взаимодействие с Danny Clans.", desc: "Спокойно уверенные, технически сложные, прозрачные." };
ru.sections.jurisdiction = { eyebrow: "Юрисдикция и управление", title: "Почему регистрация в САР Гонконг имеет значение.", desc: "Гонконг обеспечивает глобально соответствующие операции и мировое признание — намеренный выбор для институционального трансграничного партнёра." };
ru.sections.whyPartner   = { eyebrow: "Почему мы", title: "Шесть причин, по которым продвинутые операторы выбирают Danny Clans Media." };

ru.common.mostPopular = "Самый популярный";
ru.common.whatsappCta = "Написать в WhatsApp";
ru.common.whatsappPrefill = "Здравствуйте, Danny Clans! Хотел бы узнать больше о DC Dashboard и доступе к агентским рекламным аккаунтам.";
ru.common.telegramCta = "Написать в Telegram";
ru.common.limitations = "Ограничения";
ru.common.included = "Включено";
ru.common.notIncluded = "Не включено";
ru.common.primaryChannels = "Основные каналы";
ru.common.localPlaybook = "Локальный плейбук";
ru.common.priorityMarkets = "Приоритетные рынки";
ru.common.marketEntryChecklist = "Чек-лист выхода на рынок";
ru.common.stepLabel = "Шаг";
ru.common.standardEnterprise = "Стандартные планы · Enterprise уровень настраивается индивидуально";
ru.common.enterpriseWhitelabel = "Enterprise · White-label";
ru.common.whatWeWillNotDoTitle = "Что мы не делаем";
ru.common.whatWeWillNotDoItems = [
  "Гарантировать конкретный ROAS, CPA или эффективность кампании.",
  "Работать вне предоплаченной структуры или с нераскрытыми маржами.",
  "Обходить политику платформ или регуляторные требования ради краткосрочной выгоды.",
];
ru.common.governedCapability = "{{module}} — управляемая возможность";
ru.common.governedBody = "Каждая возможность поставляется с соответствием политикам, аудиторскими логами и стандартизированной отчётностью. Надёжность — это функция, а не апгрейд.";
ru.common.governedBullets = ["Задокументированные SOP", "Соответствие политикам платформ", "Готово к white-label (Media Buyer Scales++)"];
ru.common.paymentNote = "Кошелёк в долларах США. Средства зачисляются на ваш основной баланс и могут быть направлены на любой подключённый канал.";
ru.common.transparentLimits = {
  title: "Прозрачные границы сервиса",
  body: "Мы предоставляем инфраструктуру и рамки комплаенса. Мы не гарантируем эффективность кампаний, уровень одобрения объявлений или срок жизни аккаунтов.",
  items: ["Прежде всего надёжные системы", "Задокументированные границы сервиса", "Без навязчивых продаж", "Без скрытых маржей"],
};

ru.content.services = {
  launch: "DC Dashboard — Launch (Бесплатно)",
  growth: "DC Dashboard — Growth",
  scale: "DC Dashboard — Scale",
  dominance: "DC Dashboard — Dominance",
  enterprise: "Media Buyer Scales++ (Enterprise)",
  provisioning: "Обеспечение рекламного аккаунта",
  walletHelp: "Помощь с пополнением кошелька",
  whiteLabel: "White-label / агентское партнёрство",
  complianceConsult: "Консультация по комплаенсу и политикам",
};

ru.content.pricing = {
  launch:     { name: "Launch", tagline: "Протестируйте платформу без риска.", target: "Индивидуальные медиабайеры и компании, тестирующие трансграничную рекламу.", includes: ["Обеспечение аккаунта на одной платформе", "Стандартная документация по комплаенсу", "Чат поддержки (через панель)", "Базовая техническая интеграция", "Доступ к 1 платформе (Meta / Google / TikTok)"], limits: ["Нет мультиплатформенного доступа", "URL и креативы требуют одобрения", "Максимум 5 аккаунтов / месяц", "Ответ поддержки за 24 часа"], cta: "Начать с Launch" },
  growth:     { name: "Growth", tagline: "Мультиканальные кампании с реальной поддержкой.", target: "Компании, вырастающие за пределы одного канала.", includes: ["Мультиплатформенное обеспечение аккаунта", "Группа поддержки WhatsApp / Telegram", "Время обработки 12 часов", "Базовая техническая интеграция", "Мультиплатформенное распределение бюджета", "Гид по онбордингу аккаунта"], limits: ["Нет доступа к нативным рекламным платформам", "Тарифы пополнения ниже, чем в Launch", "Максимум 20 аккаунтов / месяц"], cta: "Выбрать Growth" },
  scale:      { name: "Scale", tagline: "Все платформы, персональный менеджер, приоритетный SLA.", target: "Бренды и агентства, масштабирующиеся на всех крупных каналах.", includes: ["Обеспечение на всех платформах (включая нативные)", "Группа поддержки WhatsApp / Telegram", "Приоритетная поддержка (~8 ч)", "Персональный аккаунт-менеджер", "Доступ ко всем платформам"], limits: ["Без персонального стратега", "Стандартная документация по комплаенсу", "Email за 48 часов", "Максимум 40 аккаунтов / месяц"], cta: "Выбрать Scale" },
  dominance:  { name: "Dominance", tagline: "Сервис институционального уровня, полный комплаенс, безлимитные аккаунты.", target: "Институциональные рекламодатели, требующие максимального стандартного уровня.", includes: ["Всё из Scale, плюс:", "Быстрая поддержка (1–2 ч)", "Персональный эксперт по рекламе", "Поддержка креативного производства", "Консультации по оптимизации (4 ч / месяц)", "Безлимитные аккаунты", "Стратегические обзоры", "Кастомные отчёты", "Кастомные воркфлоу и настройка AI-инструментов", "Ускоренное обеспечение"], limits: [], cta: "Выбрать Dominance" },
  mediabuyer: { name: "Media Buyer Scales++", tagline: "МЫ МАСШТАБИРУЕМ ТО, ЧТО НЕ МОГУТ ДРУГИЕ.", target: "Крупные агентства, медиабаинговые организации и enterprise-рекламодатели с высокими объёмами трат на несколько брендов и регионов.", includes: ["Всё из Dominance, плюс:", "White-label reporting suite (под вашим брендом)", "Сниженные комиссии за пополнение (B2B ставки)", "Приоритетные enterprise цены", "Приоритетная обработка платежей", "Консолидированный биллинг", "Скидки за объём", "Enterprise кредитная линия (по одобрению)", "Помощь с онбордингом клиентов", "Консалтинг по масштабированию агентства", "Оптимизация процессов агентства", "Тренинги для команды", "Гид по SOP", "Обзоры стратегии удержания клиентов", "Оценка возможностей роста", "Консультация по расширению выручки"], limits: [], cta: "Связаться с enterprise" },
};

ru.content.pricingFaqs = [
  { q: "Цены фиксированные?", a: "Стандартные планы (Launch / Growth / Scale / Dominance) — с фиксированной месячной оплатой. Media Buyer Scales++ — индивидуальное enterprise-обязательство." },
  { q: "Рекламные бюджеты включены?", a: "Нет. Месячная плата покрывает доступ, обеспечение аккаунтов, поддержку и панель. Рекламные бюджеты пополняются отдельно в вашем кошельке." },
  { q: "Какие способы оплаты принимаются?", a: "Банковский перевод (USD), Visa/Mastercard, UPI (Индия), кошелёк INR и стейблкоины." },
  { q: "Можно ли переходить между планами?", a: "Да. Апгрейд в любой момент из панели. Даунгрейд применяется к следующему циклу." },
  { q: "Что такое «B2B ставки пополнения»?", a: "Сниженные комиссии при переводе средств из кошелька на рекламные аккаунты. Лучшие ставки — на уровне Media Buyer Scales++." },
];

ru.content.dashboardFaqs = [
  { q: "Какие каналы поддерживает DC Dashboard?", a: "Meta, Google, TikTok, YouTube, Bing, LinkedIn, Snapchat, X, Reddit, Pinterest, ByteDance, Kuaishou, LINE, Naver, Outbrain, Taboola — мы расширяем список по запросу." },
  { q: "Сколько времени занимает получение агентских аккаунтов?", a: "Стандартное обеспечение — во время онбординга. Ускоренное обеспечение доступно на уровнях Dominance и Media Buyer Scales++." },
  { q: "Как пополнить кошелёк?", a: "Банковский перевод (USD), Visa/Mastercard, UPI, кошелёк INR или стейблкоины. Средства поступают на ваш основной баланс в долларах США." },
  { q: "Вы гарантируете эффективность?", a: "Нет. Мы предоставляем соответствующую инфраструктуру, агентские аккаунты, кошелёк и отчётность. Никаких гарантий эффективности, одобрения объявлений или срока жизни аккаунтов." },
  { q: "Могут ли агентства использовать white-label?", a: "Да. Уровень Media Buyer Scales++ включает white-label reporting suite, B2B ставки и сервисы масштабирования." },
];

ru.content.onboardingSteps = {
  signup: { title: "Регистрация и верификация", desc: "Создайте аккаунт Danny Clans и пройдите KYC. Документы комплаенса — на нас." },
  plan:   { title: "Выберите план", desc: "Launch (бесплатно), Growth, Scale, Dominance или Media Buyer Scales++. Апгрейд в любой момент." },
  apply:  { title: "Запросите рекламные аккаунты", desc: "Запросите агентские аккаунты на Meta, Google, TikTok, Bing, Snap, LinkedIn, YouTube, Outbrain, Taboola и других площадках." },
  topup:  { title: "Пополните кошелёк", desc: "Финансируйте USD-кошелёк через банковский перевод, карту, UPI или стейблкоины. B2B ставки на верхних уровнях." },
  launch: { title: "Запуск и масштабирование", desc: "Направляйте бюджет на любой канал, отслеживайте живые транзакции, масштабируйтесь с приоритетным SLA и персональными экспертами." },
};

// Cookie consent + navigation-level labels used by CookieConsent.jsx.
ru.cookieConsent = {
  ...en.cookieConsent,
  title: "Мы ценим вашу приватность",
  body: "Мы используем куки для работы сайта, измерения агрегированного использования и (с вашего согласия) для показа релевантных маркетинговых коммуникаций. Подробнее — в нашей ",
  privacyLink: "Политике конфиденциальности",
  acceptAll: "Принять все",
  rejectNonEssential: "Отклонить необязательные",
  preferences: "Настройки",
  managePrefs: "Управление настройками cookies",
  categoryNecessary: "Необходимые",
  categoryNecessaryDesc: "Требуются для базовой работы сайта. Не могут быть отключены.",
  categoryAnalytics: "Аналитика",
  categoryAnalyticsDesc: "Помогают понять, как посетители используют сайт (агрегированно).",
  categoryMarketing: "Маркетинг",
  categoryMarketingDesc: "Позволяют показывать релевантные объявления и измерять эффективность.",
  save: "Сохранить настройки",
};

export default ru;
